import React from 'react';
import { Box, IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
interface IProps {
  onEditClick: () => void;
}

const ProfileTableRenderCellAction = ({ onEditClick }: IProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Tooltip title="Modifica profilo">
        <IconButton onClick={onEditClick}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ProfileTableRenderCellAction;
